export default {"src":"https://webcdn.trailways.com/_next/static/media/eye.48316fc0.svg","height":14,"width":17,"blurWidth":0,"blurHeight":0};